import axios from "axios";
import $ from "jquery";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import collect from "collect.js";
import "@mdi/font/css/materialdesignicons.css";
// Don't forget the CSS: core and UI components + plugins you are using
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/webcam/dist/style.css";
import "@uppy/audio/dist/style.min.css";
import "@uppy/screen-capture/dist/style.min.css";
import "@uppy/file-input/dist/style.css";
import "@uppy/image-editor/dist/style.min.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "vue-draggable-resizable/style.css";

import "./echo";

if (typeof window !== "undefined") {
    window.axios = axios;
    window.$ = window.jQuery = $;
    window.parsePhoneNumberFromString = parsePhoneNumberFromString;
    window.collect = collect;
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
}
